export const messages = {
  en: {
    roomStructure: {
      noOwner: 'None',
      owe: 'Debt',
      yuan: 'Yuan',
      searchPlaceholder: 'Please enter room number like 1-1-1',
      building: 'Building',
      unit: 'Unit'
    }
  },
  zh: {
    roomStructure: {
      noOwner: '无',
      owe: '欠费',
      yuan: '元',
      searchPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1',
      building: '栋',
unit: '单元'
    }
  },
  'zh-TW': {
    roomStructure: {
      noOwner: '無',
      owe: '欠費',
      yuan: '元',
      searchPlaceholder: '請輸入房屋編號 樓棟-單元-房屋 如1-1-1',
      building: '棟',
      unit: '單元'
    }
  }
}